(function (h) {
    if (h.__locPatch) return;
    const P = h.pushState,
        R = h.replaceState,
        fire = () => window.dispatchEvent(new Event("locationchange"));
    h.pushState = function () {
        const r = P.apply(this, arguments);
        fire();
        return r;
    };
    h.replaceState = function () {
        const r = R.apply(this, arguments);
        fire();
        return r;
    };
    window.addEventListener("popstate", fire);
    h.__locPatch = true;
})(window.history);

function Comp12() {
    $(document)
        .off("click.comp12")
        .on(
            "click.comp12",
            ".comp-12.compCollapse .compCollapse-toggle .btn, .comp-12-footer .btn",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).closest(".comp-12.compCollapse").toggleClass("show");
            }
        );

    const closeAll = () => $(".comp-12.compCollapse").removeClass("show");

    $(window)
        .off(".comp12")
        .on("hashchange.comp12 locationchange.comp12", closeAll);
}
Comp12();
